import React, { FunctionComponent, useEffect } from "react";

import cls from 'classnames';

import { useDeviceSize } from "../../utils/useDeviceSize";
import { SIZES } from "../../common/screen";

import { Courses } from "./Curses";
import { Certificates } from "./Certificates";
import { Points } from "./Points";
import { Sessions } from "./Sessions";
import { Badges } from "./Badges";
import { Time } from "./Time";
import { Ranks } from "./Ranks";

import styles from './infographic.module.scss';
import { useDispatch } from "react-redux";
import { fetchBadgesPoints, fetchPoints } from "../../../features/students/pointsSlice";
import { fetchRanking } from "../../../features/students/rankingSlice";
import { fetchSessionInfo } from "../../../features/students/sessionInfoSlice";
import { fetchCoursesCounts } from "../../../features/students/coursesCountsSlice";

interface IInfographic {
  userId?: string;
  companyId?: string;
}

export const Infographic: FunctionComponent<IInfographic> = ({userId, companyId}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPoints(userId));
    dispatch(fetchBadgesPoints(userId));
    dispatch(fetchRanking(companyId));
    dispatch(fetchSessionInfo(userId));
    dispatch(fetchCoursesCounts(userId));
  }, [dispatch, userId, companyId]);

  const size = useDeviceSize();
  const isMobile = size === SIZES.PHONE || size === SIZES.TABLET;

  // Un único árbol de JSX: en mobile solo cambian las clases de layout
  // (ver .stack en infographic.module.scss), nunca el tipo/posición de los
  // componentes. Antes había dos `return` con subárboles distintos según
  // `isMobile`, y como ese valor cambia de PHONE (default de useDeviceSize)
  // al tamaño real luego del primer render, React desmontaba y volvía a
  // montar Points/Certificates/Courses/Sessions/Badges/Time/Ranks, disparando
  // sus fetches (incluido el de usuarios en Ranking) por duplicado.
  return <div className={cls(styles.container, { [styles.mobile]: isMobile })}>
    <div className={styles.twoColumns}>
      <div className={styles.column}><Points companyId={companyId ?? ''} isMobile={isMobile} /></div>
      <div className={styles.column}><Certificates userId={userId} /></div>
    </div>
    <div className={cls(styles.twoColumns, { [styles.stack]: isMobile })}>
      <div className={styles.column}><Courses /></div>
      <div className={styles.column}><Sessions isMobile={isMobile} /></div>
    </div>
    <div className={styles.oneColumn}>
      <Badges companyId={companyId ?? ''} isMobile={isMobile} />
    </div>
    <div className={cls(styles.twoColumns, { [styles.stack]: isMobile })}>
      <div className={cls(styles.column, styles.small)}><Time isMobile={isMobile} /></div>
      <div className={cls(styles.column, styles.wide)}><Ranks isMobile={isMobile} userId={userId} /></div>
    </div>
  </div>;
};
